import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-modal-mensaje-usuario',
  templateUrl: './modal-mensaje-usuario.component.html',
  styleUrls: ['./modal-mensaje-usuario.component.css']
})
export class ModalMensajeUsuarioComponent implements OnInit {
  @Input() mensaje
  @Input() tipo: boolean = true
  @Input() icono
  
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-mensaje-usuario/modal-mensaje-usuario.component.ts